import { Alert as ChakraAlert, HStack, VStack } from "@chakra-ui/react"
import { CloseButton } from "./CloseButton"
import * as React from "react"
import "./Alert.scss"

export interface AlertProps extends Omit<ChakraAlert.RootProps, "title"> {
  startElement?: React.ReactNode
  endElement?: React.ReactNode
  title?: React.ReactNode
  icon?: React.ReactElement
  closable?: boolean
  onClose?: () => void
  customStyle?: "neutral" | "beta"
}

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  const { title, children, icon, closable, onClose, startElement, endElement, customStyle, ...rest } = props

  return (
    <ChakraAlert.Root ref={ref} {...rest} className={`${customStyle ? `hydrologiq-alert-${customStyle}` : ""}`}>
      <HStack>
        {startElement || <ChakraAlert.Indicator>{icon}</ChakraAlert.Indicator>}
        {children ? (
          <ChakraAlert.Content>
            <ChakraAlert.Title fontWeight="semibold">{title}</ChakraAlert.Title>
            <ChakraAlert.Description>{children}</ChakraAlert.Description>
          </ChakraAlert.Content>
        ) : (
          <ChakraAlert.Title flex="1">{title}</ChakraAlert.Title>
        )}
      </HStack>
      {endElement}
      {closable && (
        <CloseButton
          variant="hydrologiq_icon"
          size="sm"
          pos="relative"
          top="-2"
          insetEnd="-2"
          alignSelf="flex-start"
          onClick={onClose}
        />
      )}
    </ChakraAlert.Root>
  )
})
